import React, { useState, FormEvent } from "react";

const Password = (props: any) => {
  const [inputType, setInputType] = useState("password");
  const [hasValue, setHasField] = useState("");

  function handleDisplayPassword(event: FormEvent) {
    event.preventDefault();
    setInputType(inputType === "password" ? "text" : "password");
  }

  function handleBlur(e: any) {
    if (e.target.value !== "") setHasField("form__input--hasValue");
    else setHasField("");
  }
  
  return (
    <div className="form-group form__password">
      <label htmlFor={props.name} className="form-label form__label">
        {props.title}
      </label>
      <input
        className={`form-input form__input ${hasValue} ${props.className || ""}`}
        id={props.id || props.name}
        name={props.name}
        type={inputType}
        defaultValue={props.value}
        onChange={props.handleChange}
        onKeyUp={props.onKeyUp}
        placeholder={props.placeholder}
        onBlur={(e) => { handleBlur(e); }}
        readOnly={props.readOnly}
        disabled={props.disabled}
        autoComplete='new-password'
      />
      <button className={`togglePassword togglePassword--${inputType}`} onClick={handleDisplayPassword} > </button>
    </div>
  );
};

export default Password;
